import { FunctionComponent } from "react";
import { Option, OptionsSelect, OptionsSelectProps } from "@bps/fluent-ui";
import { useBusinessRoles } from "@libs/api/gateways/plt/plt-gateway.hooks";
import { BusinessRoleDto } from "@libs/api/gateways/plt/plt-gateway.dtos";

export interface BusinessRolesSelectProps
  extends Omit<OptionsSelectProps, "options" | "multiSelect"> {
  application?: string;
  businessRoles?: string[];
}

export const BusinessRolesSelect: FunctionComponent<BusinessRolesSelectProps> = ({
  businessRoles,
  application,
  ...rest
}) => {
  const { isLoading, error, data = [] } = useBusinessRoles(businessRoles);

  const options: Option<BusinessRoleDto>[] = data
    .filter(p => {
      if (!application) return true;
      return p.code?.startsWith(application);
    })
    .map(data => ({
      key: data?.code ?? "No code returned.",
      text: data?.text ?? "No text returned.",
      disabled: !data?.code || !data.text,
      data
    }));

  return (
    <OptionsSelect
      options={options}
      errorMessage={error?.message}
      loading={isLoading}
      multiSelect
      {...rest}
    />
  );
};
